export default "__VITE_ASSET__40c41d40__"